import { render, staticRenderFns } from "./TermoAdesao.vue?vue&type=template&id=a258d66e"
import script from "./TermoAdesao.vue?vue&type=script&lang=js"
export * from "./TermoAdesao.vue?vue&type=script&lang=js"
import style0 from "./TermoAdesao.vue?vue&type=style&index=0&id=a258d66e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports